import React from "react";
import { Box, Grid, Typography, Paper, Container } from "@mui/material";
import imgUrl from "../../assets/images/imgUrl";

const highlights = [
  {
    title: "Contribution:",
    description: "Free for Youth under 18, USD 21 per School Representative (one-time only).",
    colorClass: "gradient-blue",
    image: imgUrl.contriIcon,
  },
  {
    title: "Eligibility:",
    description: "Minimum 40% of the Campus Representative Body enrolled.",
    colorClass: "gradient-yellow",
    image: imgUrl.eligibilityIcon,
  },
  {
    title: "Goal:",
    description: "Empower Youth to with 7 human values.",
    colorClass: "gradient-blue",
    image: imgUrl.goalIcon,
  },
  {
    title: "Global reach:",
    description: "Active in all continents.",
    colorClass: "gradient-yellow",
    image: imgUrl.goalReachIcon,
  },
];

const whyJoin = [
  <>
    Introduce Youth to the core  human values: Gratitude, {" "}
    Forgiveness, Love, Humility, Giving, Patience  and Truth.
  </>,
  <>
    Improve emotional  intelligence, compassion  and Global
    awareness.
  </>,

  <>
    Receive official <i>I Am  Peacekeeper </i> Schools 
    certification & Global  recognition.
  </>,
  <>
    Join a network of Schools  across all continents  spreading
    Peace.
  </>,
  <>
    Integrate seamlessly with  existing moral science, 
    ethics & character- building programmes.
  </>,
  <>
    Be featured in Global  campaigns, Social Media, {" "}
    Summits and <i>I Am Peacekeeper </i>  Schools  projects.
  </>,
  <>
    Empower Teachers  with ready-made value-  education Courses
    and  <i>I Am Peacekeeper </i>    Certificates.
  </>,
  <>
    Nominate deserving  students for international  <i>I Am
    Peacekeeper </i>   Ambassador recognition.
  </>,
  <>
    Compete in <i>I Am  Peacekeeper </i>  of the Year  contests.
  </>,
  <>
    Host international  <i>I Am Peacekeeper </i>  Talks,  Storytelling {" "}
   
     or School-led podcasts.
  </>,
  <>
    Gain media coverage  and School branding  through featured press 
    releases and digital articles.
  </>,
  <>
    Become a pioneer in  <i>I Am Peacekeeper </i>  Movement.
  </>
];

const programIncludes = [
  "7 Human Values Teaching Curriculum (PDF/online).",
  "I Am Peacekeeper assembly templates & school activities  with badges, bookmarks and posters.",
  "Access to I Am Peacekeeper videos, songs and story sessions.",
  "Listing of your school on our official websites.",
  "Recognition at the international I Am Peacekeeper Education Summit.",
  "Support for school‑based I Am Peacekeeper clubs, projects and annual Peace Days.",
  "Dedicated I Am Peacekeeper School login to our digital platforms.",
];

const sdgs = [
  {
    title: "SDG 4",
    description: (
      <>
        "Quality Education – <br></br> Infusing human values in <br></br> higher
        education
      </>
    ),

    icon: imgUrl.sdg4Icon,
  },
  {
    title: "SDG 16",
    description: (
      <>
        Peace, Justice & Strong <br></br> Institutions – Nurturing <br></br>{" "}
        conscious student leaders
      </>
    ),
    icon: imgUrl.sdg16Icon,
  },
  {
    title: "SDG 3",
    description: (
      <>
        Good Health & Well-being <br></br> – Emotional and mental <br></br>{" "}
        wellness via values <br></br> training
      </>
    ),
    icon: imgUrl.sdg3Icon,
  },
  {
    title: "SDG 5",
    description: (
      <>
        Gender Equality – <br></br> Promoting inclusion, <br></br> empathy, and
        respect
      </>
    ),
    icon: imgUrl.sdg5Icon,
  },
  {
    title: "SDG 10",
    description: (
      <>
        "Reduced Inequalities <br></br> – Building unity across <br></br>{" "}
        communities and cultures
      </>
    ),
    icon: imgUrl.sdg10Icon,
  },
  {
    title: "SDG 17",
    description: (
      <>
        Partnerships for the <br></br> Goals – International <br></br>{" "}
        collaboration for peace
      </>
    ),
    icon: imgUrl.sdg17Icon,
  },
];

const campus = [
   {
    title: "Contribution:",
    description: "USD 21 per Campus Representative (one‑time only). Free for Youth under 18.",
    colorClass: "gradient-blue",
    image: imgUrl.contriIcon,
  },
  {
    title: "Eligibility:",
    description: "Minimum 40% of the Campus Representative Body enrolled.",
    colorClass: "gradient-yellow",
    image: imgUrl.eligibilityIcon,
  },
  {
    title: "Goal:",
    description: (
      <>
       Empower Youth to become I Am <i> Peacekeeper </i>  leaders of tomorrow.
      </>
    ),
    colorClass: "gradient-blue",
    image: imgUrl.goalIcon,
  },
  {
    title: "Global reach:",
    description:
      "Active in all continents.",
    colorClass: "gradient-yellow",
    image: imgUrl.goalReachIcon,
  },
];

const whyCampuses = [
  <>
    Become a part of <br></br> <i>I Am Peacekeeper </i>  Campuses  <br></br> and promote Global{" "}
    <br></br> citizenship.
  </>,
  <>
    Instill 7 Core human <br></br> values in Youth.
  </>,

  <>
    Join a network of socially <br></br> conscious institutions <br></br>
    across the world.
  </>,
  <>
    Lead <i> I Am Peacekeeper </i> <br></br> initiatives,
    debates and <br></br> service projects.
  </>,
  <>
    Be part of <i>Global Justice, <br></br> Love & Peace </i>  campaigns, <br></br> Youth
    summits and inter -<br></br> university challenges.
  </>,
  <>
    Receive an <i>I Am <br></br> Peacekeeper </i>  Campus <br></br>
    certificate and Global features.
  </>,
  
  <>
    Boost campus leadership, <br></br> emotional intelligence <br></br> and
    social responsibility.
  </>,
];

const campusReceives = [
  <>
   <i>I Am Peacekeeper </i>  Campuses Certificate and Global listing.
  </>,
  <>
      Global Campus <i>I Am Peacekeeper Movement </i>  websites.
  </>,
  
  " Speaker sessions and virtual workshops.",
  <>
    <i> I Am Peacekeeper </i> film screenings and event templates.
  </>,
 <>
   Recognition at the international <i>I Am Peacekeeper </i> Summit.
 </>,
 <>
    Recognition for <i>I Am Peacekeeper </i>  Clubs and Campus bodies.
 </>,
  
  "Invitations to Global campaigns, Youth summits and inter‑university challenges."
];

const campusPeace = [
  {
    text: "Empower your campus. Elevate your institution.",
    colorClass: "gradient-blue",
  },
  {
    text:
      "Let your campus become a hub for values, dialogue and impact.",
    colorClass: "gradient-yellow",
  },
  {
    text: "Join the I Am Peacekeeper Movement. Shape the future.",
    colorClass: "gradient-blue",
  },
  {
    text:
      "Inspire Youth leadership and service on campus.",
    colorClass: "gradient-yellow",
  },
];

const CircleBox = ({
  title,
  description,
  colorClass = "gradient-green",
  image,
}) => (
  <Box
    className={`circleBox ${colorClass}`}
    sx={{
      width: 180,
      height: 180,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 4,
      m: "auto",
    }}
  >
    <img
      src={image || imgUrl.defaultIcon}
      alt={`${title} icon`}
      style={{ width: 40, height: 40, marginBottom: 1 }}
    />
    <Typography variant="subtitle1" fontWeight="bold">
      {title}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
      {description}
    </Typography>
  </Box>
);

const InfoCard = ({ text }) => (
  <Paper elevation={3} className="infoCard">
    <Typography variant="body2">{text}</Typography>
  </Paper>
);

const ProgramCard = ({ text }) => (
  <Paper elevation={3} className="programCard">
    <Typography variant="body2">{text}</Typography>
  </Paper>
);

const CampusBeconCard = ({ text, colorClass }) => (
  <Paper elevation={3} className={`programCard ${colorClass}`}  sx={{
      width: 180,
      height: 180,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 2,
      m: "auto",
    }}>
    <Typography variant="body2">{text}</Typography>
  </Paper>
);

const SchoolCampuses = () => {

  console.log("imgUrl",imgUrl.doveImg)

  return (
    <>
      {/* School Hero Background Section */}
      <Box
        className="programSchoolSectionBg commonBannerBg"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          px: 2,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 80,
            left: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={require("../../assets/images/homeimages/dovePeace.png")}
            
            alt="Peace Dove Logo"
            sx={{ maxWidth: 200, height: "auto", mr: 1 }}
          />
        </Box>
      </Box>

      {/* Main Heading */}
      <Box
        mt={5}
        className="d-flex-align-center-justify-center w-100 flex-direction-column"
      >
        <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid
            item
            xs={12}
            className="d-flex-align-center-justify-center w-100 flex-direction-column"
          >
            <img
              src={imgUrl.peaceIcon}
              className="w-100 peaceImg"
              alt="Peacekeeper Icon"
            />
            <Typography variant="h5" className="founder-title mainHeading green-title">
            <i> I Am Peacekeeper </i>  Schools
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* Main Program Section */}
      <Box p={4} className="schoolProgramMainSection schoolCircleBox">
        {/* Highlights Circles */}
        <Container className="paddingContainer">
          <Grid container spacing={0} justifyContent="center" mb={4} className="schoolGridCards">
            {highlights.map((item, index) => (
              <Grid size={{ xs: 12, md: 3, sm: 5 }} key={index}>
                <CircleBox
                  title={item.title}
                  description={item.description}
                  colorClass={item.colorClass}
                  image={item.image}
                />
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* Why Join Section */}
        <Typography
          variant="h5"
          align="center"
          fontWeight="bold"
          gutterBottom
          mt={5}
          className="subHeading mt-50px"
        >
          Why Schools Should Join
        </Typography>
        <Container className="paddingSubContainer">
          <Grid container spacing={1} mt={5} mb={2} justifyContent="center">
            {whyJoin.map((text, index) => (
              <Grid size={{ xs: 12, md: 3, sm: 6 }} key={index}>
                <InfoCard text={text} 
                 />
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* Program Includes Section */}
        {/* <Typography
          variant="h5"
          align="center"
          fontWeight="bold"
          gutterBottom
          className="subHeading mt-50px"
        >
          Program Includes
        </Typography>
        <Container className="paddingSubContainer programCardContainer">
          <Grid
            container
            spacing={2}
            mt={1}
            justifyContent="center"
            alignItems="center"
            display="flex"
          >
            {programIncludes.map((text, index) => (
              <Grid
                size={{ xs: 12, md: 3, sm: 4 }}
                key={index}
                justifyContent="center"
                alignItems="center"
                display="flex"
              >
                <ProgramCard text={text} />
              </Grid>
            ))}
          </Grid>
        </Container> */}
      </Box>

      {/* united nation section */}
      {/* <Box className="sdgSection unitedSdgSection mt-30px">
        <Typography
          variant="h5"
          align="center"
          fontWeight="bold"
          gutterBottom
          className="subHeading"
        >
          ALIGNED WITH UNITED NATIONS SDGS
        </Typography>

        <Container className="paddingSubContainer">
          <Grid
            container
            spacing={3}
            justifyContent="center"
            className="sdgGrid"
          >
            {sdgs.map((item, index) => (
              <Grid
                size={{ xs: 6, sm: 4, md: 4 }}
                key={index}
                className="d-flex-align-center-justify-center sdgMainCard"
              >
                <Box className="sdgCard">
                  <img src={item.icon} alt={item.title} className="sdgIcon" />
                  <div></div>
                  <div>
                    <Typography
                      variant="subtitle2"
                      fontWeight="bold"
                      className="sdgTitle"
                    >
                      {item.title}
                    </Typography>
                    <Typography variant="body2" className="sdgDescription">
                      {item.description}
                    </Typography>
                  </div>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box> */}

      {/* build peacekeeper section */}

      <Box mt={5}>
        <Typography
          variant="h5"
          align="center"
          fontWeight="bold"
          gutterBottom
          className="subHeading"
        >
          Let's Build A Generation Of I AM PEACEKEEPER
        </Typography>
        <div className="d-flex-align-center-justify-center">
          <img src={imgUrl.peaceKeeperGen} className="peaceKeeperImg"></img>
        </div>
      </Box>

      {/* Second Main Program Section */}
      <Box py={4} className="schoolProgramMainSection">
        {/* Highlights Circles */}

        <Box
          mt={5}
          className="d-flex-align-center-justify-center w-100 flex-direction-column"
        >
          <Grid container direction="column" alignItems="center" spacing={2}>
            <Grid
              item
              xs={12}
              className="d-flex-align-center-justify-center w-100 flex-direction-column"
            >
              <img
                src={imgUrl.peaceIcon}
                className="w-100 peaceImg"
                alt="Peacekeeper Icon"
              />
              <Typography variant="h5" className="founder-title mainHeading green-title">
              <i> I Am Peacekeeper </i>  Colleges - Universities
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <Container className="paddingContainer mt-50px">
          <Grid container spacing={0} justifyContent="center" mb={4} className="schoolGridCards schoolCircleBox">
            {campus.map((item, index) => (
              <Grid size={{ xs: 12, md: 3, sm: 5 }} key={index}>
                <CircleBox
                  title={item.title}
                  description={item.description}
                  colorClass={item.colorClass}
                  image={item.image}
                />
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* Why campuses join Section */}
        <Box className="campusesMovementSection" mt={5}>
          <Typography
            variant="h5"
            align="center"
            fontWeight="bold"
            gutterBottom
            className="subHeading"
            pt={5}
          >
            Why Campuses Should Join The Movement
          </Typography>
          <Container className="paddingSubContainer pb-16px">
            <Grid container spacing={2} mt={1} mb={4} justifyContent="center">
              {whyCampuses.map((text, index) => (
                <Grid size={{ xs: 12, md: 3, sm: 6 }} key={index}>
                  <InfoCard text={text} />
                </Grid>
              ))}
            </Grid>
          </Container>
          <Box justifyContent="center" alignItems="center" display="flex">
            <img src={imgUrl.whyCampuses} className="w-100 movementTogether"></img>
          </Box>
        </Box>

        {/* CAMPUS RECEIVES Section */}
        <Typography
          variant="h5"
          align="center"
          fontWeight="bold"
          gutterBottom
          className="subHeading mt-50px"
        >
          I Am Peacekeeper Campuses Receive
        </Typography>
        <Container className="paddingSubContainer programCardContainer">
          <Grid
            container
            spacing={2}
            mt={1}
            justifyContent="center"
            alignItems="center"
            display="flex"
          >
            {campusReceives.map((text, index) => (
              <Grid
                size={{ xs: 12, md: 3, sm: 4 }}
                key={index}
                justifyContent="center"
                alignItems="center"
                display="flex"
              >
                <ProgramCard text={text} />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

    

      {/* campus beacon section */}
      {/* <Box className="campusPeaceSection mt-50px">
        <Typography
          variant="h5"
          align="center"
          fontWeight="bold"
          gutterBottom
          className="subHeading"
          mt={5}

        >
          LET YOUR CAMPUS BE A BEACON OF PEACE
        </Typography>
        <Container className="paddingContainer mt-50px SchoolCampusPeaceSection">
          <Grid container spacing={5} justifyContent="center" mb={4}>
           {campusPeace.map(({ text, colorClass }, index) => (
            <Grid size={{ xs: 12, sm: 4 , md:3 }} key={index}>
                <CampusBeconCard text={text} colorClass={colorClass} />
            </Grid>
            ))}

          </Grid>
        </Container>
      </Box> */}
              {/* united nation section */}
      <Box className="sdgSection">
        <Typography
          variant="h5"
          align="center"
          fontWeight="bold"
          gutterBottom
          className="subHeading"
        >
          Aligned With United Nations SDGS
        </Typography>

        <Container className="paddingSubContainer">
          <Grid
            container
            spacing={3}
            justifyContent="center"
            className="sdgGrid"
          >
            {sdgs.map((item, index) => (
              <Grid
                size={{ xs: 6, sm: 4, md: 4 }}
                key={index}
                className="d-flex-align-center-justify-center sdgMainCard"
              >
                <Box className="sdgCard">
                  <img src={item.icon} alt={item.title} className="sdgIcon" />
                  <div></div>
                  <div>
                    <Typography
                      variant="subtitle2"
                      fontWeight="bold"
                      className="sdgTitle"
                    >
                      {item.title}
                    </Typography>
                    <Typography variant="body2" className="sdgDescription">
                      {item.description}
                    </Typography>
                  </div>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
      {/* contact section */}
      {/* <Box className="contactSchoolSection">
        <Typography
          variant="h5"
          align="center"
          fontWeight="bold"
          gutterBottom
          className="subHeading"
          mt={5}
          style={{marginBottom:"22px"}}
        >
          CONTACT
        </Typography>
        <div className="d-flex-align-center-justify-center flex-direction-column">
          <Typography variant="h6" className="contactPerson">
            Lord Jason Temasfieldt
          </Typography>
          <Typography>
            International Director, I Am Peacekeeper Movement
          </Typography>
          <p className="mt-0px mb-0px">
            <b>Phone:</b>
             
              <Link href="tel:+36 70359 1816" className='cursor-pointer'> +36 70359 1816 </Link> 
          
          </p>
          <p className="mt-10px mb-0px">
            <b>Email: </b>
            <Link href="mailto:jason@i-am-peacekeeper.com" className='cursor-pointer'>jason@i-am-peacekeeper.com </Link> 
          </p>
        </div>
      </Box> */}

      
    </>
  );
};

export default SchoolCampuses;
